module.exports = __webpack_public_path__ + "static/img/beta_bg_07.f3600847.svg";